import { app } from 'zapatos/schema';
import { IconName } from '../icons';

export const HISTORICAL_MONTHS = 3;
export const AMOUNT_BY_MONTH_FORMAT = 'MMM YYYY';
export const UNKNOWN_MERCHANT_ID = 'unknown';
export const SUPERCATEGORIES: app.supercategory[] = [
    'INCOME',
    'TRANSFERS',
    'SAVING_INVESTING',
    'SPENDING',
];

// There are a bunch of "custom" icons that we don't want to show in the icon select - using an explicit list of what we _do_ want to include
export const CUSTOM_ICONS: IconName[] = [
    'AppleLogo',
    'ATM',
    'BaseballHat',
    'Bicycle',
    'CarPayment',
    'Chair',
    'Childcare',
    'Coffee',
    'ConcentricCircles',
    'CurrencyDollarCircleDots',
    'Doctor',
    'Dog',
    'FastFood',
    'FemaleSign',
    'Firearms',
    'FoodDrink',
    'Gas',
    'GoalBaby',
    'GoalCar',
    'GoalCashManagement',
    'GoalCollege',
    'GoalCustom',
    'GoalDaycare',
    'GoalDebt',
    'GoalEmergencyFund',
    'GoalHome',
    'GoalInvesting',
    'GoalMarriage',
    'GoalRetirement',
    'GoalVacation',
    'Gym',
    'HairBeauty',
    'HandOff',
    'HomeImprovement',
    'Horseshoe',
    'Laundry',
    'Lodging',
    'OverlappingCircles',
    'Parking',
    'Pause',
    'PersonalCare',
    'Pharmacy',
    'PlentyLogo',
    'Prison',
    'Restaurant',
    'RothIRA',
    'Shirt',
    'Tobacco',
    'TraditionalIRA',
    'TriangleDown',
    'TriangleUp',
    'TwoPeople',
    'VendingMachine',
    'VeterinaryServices',
    'WineGlass',
];
